
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mattermost",
      function () {
        return require("private-next-pages/destinations/mattermost.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mattermost"])
      });
    }
  